'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.currencyCodeLoaded = exports.currencyCodeChange = exports.catExchangeRatesLocallyLoaded = exports.catExchangeRatesFetchFailed = exports.catExchangeRatesFetched = exports.ethExchangeRatesLocallyLoaded = exports.ethExchangeRatesFetchFailed = exports.ethExchangeRatesFetched = undefined;

var _actionTypes = require('../actionTypes');

var ethExchangeRatesFetched = exports.ethExchangeRatesFetched = function ethExchangeRatesFetched(ethExchangeRates) {
  return {
    type: _actionTypes.ETH_EXCHANGE_RATES_FETCHED,
    ethExchangeRates: ethExchangeRates
  };
};

var ethExchangeRatesFetchFailed = exports.ethExchangeRatesFetchFailed = function ethExchangeRatesFetchFailed(error) {
  return {
    type: _actionTypes.ETH_EXCHANGE_RATES_FETCH_FAILED,
    error: error
  };
};

var ethExchangeRatesLocallyLoaded = exports.ethExchangeRatesLocallyLoaded = function ethExchangeRatesLocallyLoaded(ethExchangeRates) {
  return {
    type: _actionTypes.ETH_EXCHANGE_RATES_LOCALLY_LOADED,
    ethExchangeRates: ethExchangeRates
  };
};

var catExchangeRatesFetched = exports.catExchangeRatesFetched = function catExchangeRatesFetched(catExchangeRates) {
  return {
    type: _actionTypes.CAT_EXCHANGE_RATES_FETCHED,
    catExchangeRates: catExchangeRates
  };
};

var catExchangeRatesFetchFailed = exports.catExchangeRatesFetchFailed = function catExchangeRatesFetchFailed(error) {
  return {
    type: _actionTypes.CAT_EXCHANGE_RATES_FETCH_FAILED,
    error: error
  };
};

var catExchangeRatesLocallyLoaded = exports.catExchangeRatesLocallyLoaded = function catExchangeRatesLocallyLoaded(catExchangeRates) {
  return {
    type: _actionTypes.CAT_EXCHANGE_RATES_LOCALLY_LOADED,
    catExchangeRates: catExchangeRates
  };
};

var currencyCodeChange = exports.currencyCodeChange = function currencyCodeChange(currencyCode) {
  return {
    type: _actionTypes.CURRENCY_CODE_CHANGED,
    currencyCode: currencyCode
  };
};

var currencyCodeLoaded = exports.currencyCodeLoaded = function currencyCodeLoaded(currencyCode) {
  return {
    type: _actionTypes.CURRENCY_CODE_LOCALLY_LOADED,
    currencyCode: currencyCode
  };
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/@blockcatio/tabby-library/lib/actions/currencyExchangeRates.js
// module id = 153
// module chunks = 0